var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0001 3.20001V5.60001H3.2001C2.77575 5.60001 2.36878 5.76858 2.06873 6.06864C1.76867 6.36869 1.6001 6.77566 1.6001 7.20001V9.60001C1.6001 10.0244 1.76867 10.4313 2.06873 10.7314C2.36878 11.0314 2.77575 11.2 3.2001 11.2H4.0001V12.8C4.0001 13.2244 4.16867 13.6313 4.46873 13.9314C4.76878 14.2314 5.17575 14.4 5.6001 14.4H10.4001C10.8244 14.4 11.2314 14.2314 11.5315 13.9314C11.8315 13.6313 12.0001 13.2244 12.0001 12.8V11.2H12.8001C13.2244 11.2 13.6314 11.0314 13.9315 10.7314C14.2315 10.4313 14.4001 10.0244 14.4001 9.60001V7.20001C14.4001 6.77566 14.2315 6.36869 13.9315 6.06864C13.6314 5.76858 13.2244 5.60001 12.8001 5.60001H12.0001V3.20001C12.0001 2.77566 11.8315 2.36869 11.5315 2.06864C11.2314 1.76858 10.8244 1.60001 10.4001 1.60001H5.6001C5.17575 1.60001 4.76878 1.76858 4.46873 2.06864C4.16867 2.36869 4.0001 2.77566 4.0001 3.20001ZM10.4001 3.20001H5.6001V5.60001H10.4001V3.20001ZM10.4001 9.60001H5.6001V12.8H10.4001V9.60001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/Printer.86e19047cfbb8e255dce0e6c21267407.svg";
export { ForwardRef as ReactComponent };